import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const BASE = (import.meta.env.VITE_API_URL as string | undefined) ?? 'http://127.0.0.1:8787';

export interface StatsWhatsAppLead {
  id: string;
  customerName: string;
  items: string;
  totalAmount: number;
  itemCount: number;
  deliveryType: 'envio' | 'retiro';
  createdAt: number;
}

export interface Stats {
  products:      { total: number; active: number };
  categories:    { total: number };
  whatsappLeads: {
    last7d: number;
    last30d: number;
    total: number;
    recent: StatsWhatsAppLead[];
  };
}

export const statsApi = createApi({
  reducerPath: 'statsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('auth_token');
      if (token) headers.set('Authorization', `Bearer ${token}`);
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getStats: builder.query<Stats, void>({
      query: () => '/api/v1/analytics/stats',
      transformResponse: (res: { status: string; data: Stats }) => res.data,
    }),
  }),
});

export const { useGetStatsQuery } = statsApi;
